@if (initialized) {
    <div class="cn-rule-preview surface-0 border-1 surface-border border-round p-3">

        <div class="flex align-items-center gap-2 mb-3">
            <i class="fa-regular fa-flask text-xl text-primary"></i>
            <span class="text-lg font-medium">Regel-Vorschau</span>
        </div>

        <p-message severity="info" class="block mb-3"
                   text="Berechnet diese Regel an einem Beispielvertrag und zeigt die Herleitung — vor dem Speichern.">
        </p-message>

        <!-- Example-contract selector -->
        <div class="flex align-items-end gap-3 mb-3 flex-wrap">
            <div class="flex flex-column gap-1">
                <label class="text-sm text-600" for="cn-preview-contract">Beispielvertrag (ID)</label>
                <p-inputNumber id="cn-preview-contract"
                               [(ngModel)]="exampleContractId"
                               [useGrouping]="false"
                               placeholder="Vertrags-ID">
                </p-inputNumber>
            </div>
            <p-button label="Vorschau berechnen"
                      icon="fa-regular fa-play"
                      [disabled]="!exampleContractId || busy"
                      [loading]="busy"
                      (onClick)="runPreview()">
            </p-button>
        </div>

        <!-- Busy / progress -->
        @if (busy) {
            <div class="mb-3">
                <p-progressBar [value]="progress"></p-progressBar>
            </div>
        }

        <!-- Error -->
        @if (errorMessage) {
            <p-message severity="error" class="block mb-2" [text]="errorMessage"></p-message>
        }

        <!-- Empty / not found -->
        @if (notFound && !busy) {
            <div class="text-600 p-3 text-center">
                Für diesen Beispielvertrag wurde keine Herleitung erzeugt.
            </div>
        }

        <!-- Result trace -->
        @if (expectation && !busy) {
            <mvs-cn-expectation-trace
                    [trace]="expectation.calculationTrace"
                    [grossAmount]="expectation.expectedGrossAmount"
                    [netAmount]="expectation.expectedNetAmount"
                    [expanded]="true"
                    title="Herleitung (Beispielvertrag)">
            </mvs-cn-expectation-trace>
        }

    </div>
}
